import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Divider } from 'ALIASED-antd';
import styled from '@emotion/styled';
import { PostcodeAutocomplete } from '../../../PostcodeAutocomplete';
import { PostcodeResponse } from './RandoxAutoCompleteSearchInput';

const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  .ant-select-selector {
    background-color: #fff !important;
  }
  .ant-select-disabled .ant-select-selector {
    background-color: #fafafa !important;
    color: #000 !important;
    cursor: default;
  }
  .ant-input[disabled],
  input[disabled] {
    color: #000 !important;
    cursor: default;
    background-color: #fafafa;
  }
  .ant-picker {
    padding: 3px 11px;
    border-radius: 2px;
  }
`;

const ConditionalReadonlyField: React.FC<{
  readOnly?: boolean;
  value?: string | number;
  children: ReactElement;
}> = ({ readOnly, value, children }) => {
  if (readOnly) {
    return <Input disabled value={value} />;
  }

  return children;
};

const PatientDetailsFormFields = ({ readOnly }: { readOnly?: boolean }) => {
  const { t } = useTranslation('common');
  const form = Form.useFormInstance();

  return (
    <>
      <FieldsContainer>
        <Form.Item name={'patient_title'} label={t('Title')}>
          <Input placeholder={t('Title')} disabled />
        </Form.Item>
        <Form.Item name={'patient_gender'} label={t('Gender')}>
          <Input placeholder={t('Gender')} disabled />
        </Form.Item>
        <Form.Item name={'patient_first_name'} label={t('First Name')}>
          <Input placeholder={t('First Name')} disabled />
        </Form.Item>
        <Form.Item name={'patient_last_name'} label={t('Last Name')}>
          <Input placeholder={t('Last Name')} disabled />
        </Form.Item>
        <Form.Item name={'patient_dob'} label={t('Date of Birth')}>
          <Input placeholder={t('Date of Birth')} disabled />
        </Form.Item>
        <Form.Item label={t('Phone number')} name="tel_no">
          <Input placeholder={t('Phone Number')} disabled />
        </Form.Item>
      </FieldsContainer>

      <Divider />

      <FieldsContainer>
        <Form.Item label={t('Postcode')} name="postcode" required={!readOnly}>
          <ConditionalReadonlyField readOnly={readOnly} value={form?.getFieldValue('postcode')}>
            <PostcodeAutocomplete
              onManualChange={() => {}}
              placeholder={t('Enter Postcode')}
              valueEx={form.getFieldValue('postcode')}
              onSelect={(addressObj: PostcodeResponse) => {
                if (!addressObj.isAddressFound) return;
                form.setFieldsValue({
                  postcode: addressObj.postcode,
                  addline1: addressObj.line1,
                  addline2: addressObj.line2,
                  addline3: addressObj.line3,
                  addline4: addressObj.town,
                  country: addressObj.country
                });
              }}
              useAntd={true}
            />
          </ConditionalReadonlyField>
        </Form.Item>
        <Form.Item label={t('Address Line 1')} name="addline1" required={!readOnly}>
          <Input placeholder={t('Address Line 1')} disabled={readOnly} />
        </Form.Item>
        <Form.Item label={t('Address Line 2')} name="addline2">
          <Input placeholder={t('Address Line 2')} disabled={readOnly} />
        </Form.Item>
        <Form.Item label={t('Address Line 3')} name="addline3">
          <Input placeholder={t('Address Line 3')} disabled={readOnly} />
        </Form.Item>
        <Form.Item label={t('Town / City')} name="addline4">
          <Input placeholder={t('Town / City')} disabled={readOnly} />
        </Form.Item>
        <Form.Item label={t('Country')} name="country">
          <Input placeholder={t('Country')} disabled={readOnly} />
        </Form.Item>
      </FieldsContainer>
    </>
  );
};

export default PatientDetailsFormFields;
